/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, useState } from "react";
import {Link} from "react-router-dom";
import Logo from '../Assets/Img/logo1.png';
import PhoneIcon from '@material-ui/icons/Phone';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import Edifice from "../Assets/Icons/ART_Icon_Edifice";
import '../Assets/Css/App.css';
import { Button} from '@material-ui/core';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import Avatar from '@mui/material/Avatar';
import Menus from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import AssignmentIcon from '@mui/icons-material/Assignment';
import PersonIcon from '@mui/icons-material/Person';
import PeopleIcon from '@mui/icons-material/People';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';

import Settings from '@mui/icons-material/Settings';
import Box from '@mui/material/Box';

const greenTheme = createMuiTheme({ palette: 
  { 
    primary:{
      light: '#83BC00',
      main: '#83BC00',
      dark: 'green',
      contrastText: '#fff',
    }
  } 
})

export default function Menu() {
 
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    
    return (

      <div>

      </div>
    );
  }